// Footer.js
import React, { useEffect } from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const mapmyvisitorsStyle = document.createElement('style');
    mapmyvisitorsStyle.id = 'mapmyvisitors-style';
    mapmyvisitorsStyle.textContent = `
      #mapmyvisitors,
      #mapmyvisitors img,
      #mapmyvisitors iframe,
      img[src*="mapmyvisitors.com"],
      iframe[src*="mapmyvisitors.com"],
      a[href*="mapmyvisitors.com"],
      div[id*="mapmyvisitors"],
      div[class*="mapmyvisitors"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        width: 0 !important;
        height: 0 !important;
        pointer-events: none !important;
        position: absolute !important;
        left: -9999px !important;
      }
    `;

    const mapmyvisitorsScript = document.createElement('script');
    mapmyvisitorsScript.type = 'text/javascript';
    mapmyvisitorsScript.id = 'mapmyvisitors';
    mapmyvisitorsScript.src = '//mapmyvisitors.com/map.js?d=5RjF0GBDu4z88R17lAfTryNaWrNfa181-Q5g6AY535o&cl=ffffff&w=a';

    const goatcounterScript = document.createElement('script');
    goatcounterScript.async = true;
    goatcounterScript.dataset.goatcounter = 'https://sayem.goatcounter.com/count';
    goatcounterScript.src = '//gc.zgo.at/count.js';
    goatcounterScript.id = 'goatcounter-script';

    document.head.appendChild(mapmyvisitorsStyle);
    document.body.appendChild(mapmyvisitorsScript);
    document.body.appendChild(goatcounterScript);

    return () => {
      mapmyvisitorsStyle.remove();
      mapmyvisitorsScript.remove();
      goatcounterScript.remove();
    };
  }, []);

  return (
    <footer className="py-8" style={{ backgroundColor: 'var(--bg-surface)', borderTop: '1px solid var(--border)' }}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="row">
          <div className="col-sm-12">
            <div className="text-center">
              <p className="mb-2" style={{ color: 'var(--text-primary)' }}>
                &copy; {currentYear}{' '}
                <a
                  href="https://www.linkedin.com/in/mohammad-sayem-chowdhury/"
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold hover:underline"
                  style={{ color: 'var(--primary)' }}
                >
                  Mohammad Sayem Chowdhury
                </a>
                . All Rights Reserved.
              </p>
              <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                Computer Science Researcher
              </p>
              <p className="text-xs mt-4" style={{ color: 'var(--text-muted)', opacity: 0.7 }}>
                Visitor analytics are powered by GoatCounter and MapMyVisitors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
